import { useState, useEffect, useContext, useRef } from "react";
import api from "../../services/api";
import Navbar from "../../Components/Navbar";
import { useNavigate } from "react-router-dom";
import truncate from "html-truncate";

import {
  Box,
  Button,
  Heading,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Image,
  useToast,
  useDisclosure,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  SimpleGrid,
  Select,
  Flex,
  HStack,
} from "@chakra-ui/react";
import { UserContext } from "../../contexts/User";
import { MateriaContext } from "../../contexts/Materia";
import { BookContext } from "../../contexts/Book";
import { RedactionContext } from "../../contexts/Redacoes";

const UserProfilePage = () => {
  const { getUserApi, updateUserApi, getUserResultsApi } =
    useContext(UserContext);
  const fileInputRef = useRef(null);
  const { listMateriaApi } = useContext(MateriaContext);
  const { createBookApi, listBookApi, deleteBookApi } = useContext(BookContext);
  const { getRedactionCompletedUserTemasApi } = useContext(RedactionContext);
  const toast = useToast();
  const navigate = useNavigate();
  const timeoutRef = useRef(null);
  const [userID, setUserID] = useState("");
  const [newBook, setNewBook] = useState("");
  const [materias, setMaterias] = useState();
  const [user, setUser] = useState(null);
  const [editedUser, setEditedUser] = useState({});
  const [materyID, setMateryID] = useState();
  const [books, setBooks] = useState();
  const [profileImage, setProfileImage] = useState("");
  const [totalResults, setResults] = useState();
  const [pagination, setPagination] = useState({});
  const [groupedNotes, setGroupedNotes] = useState([]);
  const [completedRedactions, setCompletedRedactions] = useState([]);
  // Componente separado para tabela paginável

  const {
    isOpen: isEditModalOpen,
    onOpen: onEditModalOpen,
    onClose: onEditModalClose,
  } = useDisclosure();
  const {
    isOpen: isAddNotebookModalOpen,
    onOpen: onAddNotebookModalOpen,
    onClose: onAddNotebookModalClose,
  } = useDisclosure();

  // Cadernos
  const [notebookss, setNotebooks] = useState([]);
  const [newNotebook, setNewNotebook] = useState({ subject: "", content: "" });

  const handleSelectBook = (id) => {
    localStorage.setItem("book_id", id);
    navigate(`/book/${id}`);
  };
  const handleSubjectChange = (event) => {
    setNewNotebook({ ...newNotebook, subject: event.target.value });
  };

  const handleContentChange = (content) => {
    setNewNotebook({ ...newNotebook, content });
  };

  const addNotebook = () => {
    // Lógica para adicionar o caderno à lista de cadernos
    setNotebooks([...books, newNotebook]);
    // Lógica para enviar o caderno para a API e persistir no banco de dados
    // ...
    // Limpar os campos do formulário do novo caderno
    setNewNotebook({ subject: "", content: "" });
    // Fechar o modal
    onAddNotebookModalClose();
  };

  const handleNameChange = (event) => {
    setEditedUser({ ...editedUser, name: event.target.value });
  };

  const handleEmailChange = (event) => {
    setEditedUser({ ...editedUser, email: event.target.value });
  };

  const updateUser = () => {
    // Lógica para atualizar o usuário com as informações editadas
    // ...
    onEditModalClose();
  };
  const handleCpfChange = (event) => {
    setEditedUser({ ...editedUser, cpf: event.target.value });
  };

  const handlePasswordChange = (event) => {
    setEditedUser({ ...editedUser, password: event.target.value });
  };

  const handleConfirmPasswordChange = (event) => {
    setEditedUser({ ...editedUser, confirmPassword: event.target.value });
  };

  const getBooks = async () => {
    const userID = JSON.parse(localStorage.getItem("userInfoID"));
    try {
      const booksData = await listBookApi(userID);
      console.log(booksData.data);
      setBooks(booksData.data);
      setGroupedNotes(booksData.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getCompletedRedactions = async () => {
    const userID = JSON.parse(localStorage.getItem("userInfoID"));
    console.log(userID);
    try {
      const response = await getRedactionCompletedUserTemasApi(userID);
      setCompletedRedactions(response.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  const deleteBookUser = async (id) => {
    try {
      const deleteBook = await deleteBookApi(id);
      console.log(deleteBook.data);
      if (deleteBook.status === 200) {
        toast({
          title: "Caderno deletado com Sucesso",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.log(error);
      toast({
        title: "Deu algo errado",
        status: "error",
        isClosable: true,
      });
    }
    getBooks();
  };
  const getUser = async () => {
    const userID = JSON.parse(localStorage.getItem("userInfoID"));
    try {
      const userData = await getUserApi(userID);
      setUser(userData.data?.[0]);
      setProfileImage(userData.data?.[0]?.avatar);
      console.log(userData.data);
    } catch (error) {
      console.log(error);
      window.location.pathname = "/login";
    }
  };

  // Função para lidar com a seleção de uma imagem de perfil
  // Função para lidar com a seleção de uma imagem de perfil
  const handleImageChange = (event) => {
    const image = event.target.files[0];
    setProfileImage(image);

    const formData = new FormData();
    formData.append("avatar", image);
    // Obtenha o token de autorização do localStorage
    const token = localStorage.getItem("token");

    api
      .post("upload-avatar", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        console.log(response.data.message); // Mensagem de sucesso
        getUser();
        fileInputRef.current.value = null;
      })
      .catch((error) => {
        console.error("Erro ao fazer upload: " + error.message);
      });
  };

  const getUserResults = async (ID) => {
    try {
      const results = await getUserResultsApi(userID);
      console.log(results.data?.[0]);
      setResults(results.data?.[0]);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCompletedRedactions();
    const userInfo = JSON.parse(localStorage.getItem("userInfoID"));
    if (userInfo) {
      setUserID(userInfo);
    }

    if (userID) {
      getUser(userID);
      getUserResults(userInfo);
    }
    getBooks();
  }, [userID]);

  const PaginableTable = ({ matery, questions }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(5);

    // Calcular itens paginados
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = questions.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(questions.length / itemsPerPage);

    return (
      <Box mb={8} bg="white" borderRadius="md" boxShadow="md" p={6}>
        <Flex justify="space-between" align="center" mb={4}>
          <Heading fontSize="xl">
            {matery} ({questions.length} questões)
          </Heading>

          <Select
            width="120px"
            value={itemsPerPage}
            onChange={(e) => {
              setItemsPerPage(Number(e.target.value));
              setCurrentPage(1);
            }}
          >
            <option value={5}>5 itens</option>
            <option value={10}>10 itens</option>
            <option value={20}>20 itens</option>
          </Select>
        </Flex>

        <Table variant="striped" colorScheme="gray">
          {/* Cabeçalho da tabela */}
          <Thead>
            <Tr>
              <Th>ID</Th>
              <Th>Questão</Th>
              <Th>Criada em</Th>
            </Tr>
          </Thead>

          {/* Corpo da tabela */}
          <Tbody>
            {currentItems.map((q) => (
              <Tr key={q.question_id}>
                <Td fontWeight="semibold">{q.question_id}</Td>
                <Td>
                  <Box
                    dangerouslySetInnerHTML={{ __html: q.question }}
                    fontSize="sm"
                    className="question-content"
                  />
                </Td>
                <Td>
                  {new Date(q.created_at).toLocaleDateString("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>

        {/* Controles de paginação */}
        <Flex justify="space-between" align="center" mt={4}>
          <Text fontSize="sm" color="gray.600">
            Exibindo {indexOfFirstItem + 1} a{" "}
            {Math.min(indexOfLastItem, questions.length)} de {questions.length}{" "}
            itens
          </Text>

          <HStack spacing={2}>
            <Button
              size="sm"
              onClick={() => setCurrentPage(currentPage - 1)}
              isDisabled={currentPage === 1}
            >
              Anterior
            </Button>

            <Text fontSize="sm" mx={2}>
              Página {currentPage} de {totalPages}
            </Text>

            <Button
              size="sm"
              onClick={() => setCurrentPage(currentPage + 1)}
              isDisabled={currentPage === totalPages}
            >
              Próxima
            </Button>
          </HStack>
        </Flex>
      </Box>
    );
  };
  return (
    <>
      <Navbar />
      <>
        <Box
          p={8}
          ml={{ base: 0, md: 60 }}
          bgColor={"#f0f8ff"}
          minH={"100vh"}
          mt={"-35px"}
        >
          <Box p={8} bg="white" borderRadius="md" boxShadow="md">
            <Heading as="h1" size="xl" mb={4}>
              Perfil do Usuário
            </Heading>
            <Box mb={5}>
              <Image
                borderRadius="full"
                boxSize="150px"
                src={
                  profileImage === null
                    ? "https://via.placeholder.com/150"
                    : "https://api.colegionaval.com.br/public/" + profileImage
                }
                alt={user?.name}
                mb={2}
              />
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                ref={fileInputRef}
              />
            </Box>
            <Text>
              <strong>ID:</strong> {user?.id}
            </Text>
            <Text>
              <strong>Nome:</strong> {user?.name}
            </Text>
            <Text>
              <strong>E-mail:</strong> {user?.email}
            </Text>
            <Text>
              <strong>Tipo:</strong>{" "}
              {user?.role_id === 2
                ? "Professor"
                : user?.role_id === 3
                ? "Aluno"
                : "Administrador"}
            </Text>

            <Button mt={4} colorScheme="teal" onClick={onEditModalOpen}>
              Editar Usuário
            </Button>
          </Box>
          {user?.role_id === 2 && user?.questionsByMatery && (
            <Box mt={5} p={8}>
              {Object.entries(user.questionsByMatery).map(
                ([matery, questions]) => (
                  <PaginableTable
                    key={matery}
                    matery={matery}
                    questions={questions}
                  />
                )
              )}
            </Box>
          )}
          {user?.role_id === 3 && (
            <>
              {groupedNotes?.map(({ matery, notebooks }, index) => (
                <Box
                  key={index}
                  mt={5}
                  p={8}
                  bg="white"
                  borderRadius="md"
                  boxShadow="md"
                >
                  <Text fontWeight="bold" fontSize="18px" mb={4}>
                    Cadernos: {matery}
                  </Text>

                  <Table>
                    <Thead>
                      <Tr>
                        <Td>Questão</Td>
                        <Td>Conteúdo</Td>
                        <Td>Ações</Td>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {notebooks.map((note) => (
                        <Tr key={note.id}>
                          <Td
                            style={{
                              maxWidth: "200px",
                              overflow: "hidden",
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                            }}
                            dangerouslySetInnerHTML={{
                              __html: truncate(note.question || "", 80),
                            }}
                          />
                          <Td
                            style={{
                              maxWidth: "300px",
                              overflow: "hidden",
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                            }}
                            dangerouslySetInnerHTML={{
                              __html: truncate(note.content || "", 100),
                            }}
                          />

                          <Td
                            style={{
                              maxWidth: "200px",
                              overflow: "hidden",
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <Button onClick={() => handleSelectBook(note.id)}>
                              Acessar
                            </Button>
                            <Button
                              ml={3}
                              colorScheme="red"
                              onClick={() => deleteBookUser(note.id)}
                            >
                              Excluir
                            </Button>
                          </Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </Box>
              ))}
              <Box mt={5} p={8} bg="white" borderRadius="md" boxShadow="md">
                <Heading size="md" mb={4}>
                  Redações Concluídas
                </Heading>
                {console.log}
                {completedRedactions.length === 0 ? (
                  <Text>Nenhuma redação concluída ainda.</Text>
                ) : (
                  completedRedactions.map((r) => (
                    <Box
                      key={r.id}
                      p={3}
                      borderWidth="1px"
                      borderRadius="md"
                      mb={2}
                    >
                      <Text fontWeight="bold">{r.theme_redacao}</Text>
                      <div dangerouslySetInnerHTML={{ __html: r.info }} />
                    </Box>
                  ))
                )}
              </Box>
              {totalResults != null && (
                <Box mt={5} p={8} bg="white" borderRadius="md" boxShadow="md">
                  <Text fontWeight="bold" fontSize="18px">
                    Resultados de Simulados
                  </Text>
                  <Box mt={5}>
                    <Text>Total de Respostas</Text>
                    <Box mt={5}>
                      <SimpleGrid columns={2}>
                        <Box textAlign={"center"}>
                          <Text fontWeight={"bold"}>
                            Total respostas erradas
                          </Text>
                          <Text fontSize={"24px"}>
                            {totalResults.totalAnswers?.qty_wrong}
                          </Text>
                        </Box>
                        <Box textAlign={"center"}>
                          <Text fontWeight={"bold"}>
                            Total respostas certas
                          </Text>
                          <Text fontSize={"24px"}>
                            {totalResults.totalAnswers?.qty_right}
                          </Text>
                        </Box>
                      </SimpleGrid>

                      <Table mt={5}>
                        <Tr>
                          <Td textAlign={"center"}>Id Simulado</Td>
                          <Td textAlign={"center"}>
                            Quantidade de respostas certas
                          </Td>
                          <Td textAlign={"center"}>
                            Quantidade de respostas erradas
                          </Td>
                        </Tr>
                        <Tbody>
                          {totalResults?.simulatorsResults?.map((index) => (
                            <>
                              <Tr>
                                <Td textAlign={"center"}>
                                  {index.simulator_id}
                                  {console.log(index)}
                                </Td>
                                <Td textAlign={"center"}>{index.qty_right}</Td>
                                <Td textAlign={"center"}>{index.qty_wrong}</Td>
                              </Tr>
                            </>
                          ))}
                        </Tbody>
                      </Table>
                    </Box>
                  </Box>
                </Box>
              )}
            </>
          )}
        </Box>

        <Modal isOpen={isEditModalOpen} onClose={onEditModalClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Edit User</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Text mb={2}>Name:</Text>
              <Input
                type="text"
                value={editedUser.name || user?.name}
                onChange={handleNameChange}
              />
              <Text mt={4} mb={2}>
                Email:
              </Text>
              <Input
                type="email"
                value={editedUser.email || user?.email}
                onChange={handleEmailChange}
              />
              <Text mt={4} mb={2}>
                CPF:
              </Text>
              <Input
                mask="999.999.999-99"
                value={editedUser.cpf || ""}
                onChange={handleCpfChange}
              ></Input>
              <Text mt={4} mb={2}>
                Password:
              </Text>
              <Input
                type="password"
                value={editedUser.password || ""}
                onChange={handlePasswordChange}
              />
              <Text mt={4} mb={2}>
                Confirm Password:
              </Text>
              <Input
                type="password"
                value={editedUser.confirmPassword || ""}
                onChange={handleConfirmPasswordChange}
              />
              {/* Outros campos para edição */}
            </ModalBody>
            <ModalFooter>
              <Button colorScheme="teal" mr={3} onClick={updateUser}>
                Update
              </Button>
              <Button onClick={onEditModalClose}>Cancel</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
        <Modal
          isOpen={isAddNotebookModalOpen}
          onClose={onAddNotebookModalClose}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Create New Notebook</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Text mb={2}>Subject:</Text>
              <Input
                type="text"
                value={newNotebook.subject}
                onChange={handleSubjectChange}
              />
              <Text mt={4} mb={2}>
                Content:
              </Text>
              {/* Implemente aqui o componente de editor desejado (por exemplo, CKEditor, Draft.js, etc.) */}
              {/* <Editor value={newNotebook.content} onChange={handleContentChange} /> */}
            </ModalBody>
            <ModalFooter>
              <Button colorScheme="teal" mr={3} onClick={addNotebook}>
                Add Notebook
              </Button>
              <Button onClick={onAddNotebookModalClose}>Cancel</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    </>
  );
};

export default UserProfilePage;
